import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="iso-8859-1"?>
        <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-cz" viewBox="0 0 640 480">
          <path fill="#fff" d="M0 0h640v240H0z"/>
          <path fill="#d7141a" d="M0 240h640v240H0z"/>
          <path fill="#11457e" d="M360 240 0 0v480z"/>
        </svg>
      
        `,
      }}
    />
  );
}
